// extracted by mini-css-extract-plugin
export default {"dropdown":"Notifications_dropdown__FjFDr","click":"Notifications_click__zdfL5"};